// import { UIApplicationMain } from "UIKit";
// import { MIOCoreGetMainURLString } from "MIOCore";
// import { MIOCoreRegisterClassByName } from "MIOCore";
// import { AppDelegate } from "./AppDelegate";
// import { BookingDesktopViewController } from "./scenes/BookingDesktopViewController";
// import { UIView } from "UIKit";
// import { UILabel } from "UIKit";
// import { UIButton } from "UIKit";
// import { UITextField } from "UIKit";

import { MIOCoreGetMainURLString, MIOCoreRegisterClassByName } from "mio-core";
import { UIApplicationMain, UIButton, UILabel, UISegmentedControl, UITextArea, UITextField, UIView, UICollectionView, UICollectionViewCell, UICheckButton, UITableView, UITableViewCell, UIImageView } from "uikit";
import { AppDelegate } from "./AppDelegate";
import { MUIComboBox, MUIDatePicker } from "muikit";

import '../build_tmp/css/styles.scss';
import { HeaderCell } from "./scenes/HeaderCell";
import { BookingDesktopViewController } from "./scenes/BookingDesktopViewController";
import { BookingProductViewController } from "./scenes/BookingProductViewController";
import { BookingRestaurantViewController } from "./scenes/BookingRestaurantViewController";
import { BookingClientViewController } from "./scenes/BookingClientViewController";
import { BookingCalendarViewController } from "./scenes/BookingCalendarViewController";
import { StepView } from "./scenes/StepView";
import { BookingProductCell } from "./scenes/BookingProductCell";
import { BookingProductCategoryViewController } from "./scenes/BookingProductCategoryViewController";
import { BookingProductCategoryCell } from "./scenes/BookingProductCategoryCell";
import { BookingProductCategoryHeader } from "./scenes/BookingProductCategoryHeader";
import { BookingReviewViewController } from "./scenes/BookingReviewViewController";
import { BookingReviewCell } from "./scenes/BookingReviewCell";
import { BookingProductReviewViewController } from "./scenes/BookingProductReviewViewController";


window.onload = function() {

    _register_classes();

    let url = MIOCoreGetMainURLString();
    console.log("Main URL: " + url);
    let args = [url]; // Todo get only the query string

    UIApplicationMain(args.length, args, null, "AppDelegate");
};

// output errors to console log
window.onerror = function (e) {
    console.log("window.onerror ::" + JSON.stringify(e));
};

function _register_classes(){
    // TODO: Automated this process
    MIOCoreRegisterClassByName("UIView", UIView);
    MIOCoreRegisterClassByName("UILabel", UILabel);
    MIOCoreRegisterClassByName("UIButton", UIButton);
    MIOCoreRegisterClassByName("UITextField", UITextField);
    MIOCoreRegisterClassByName("UITextArea", UITextArea);
    MIOCoreRegisterClassByName("UISegmentedControl", UISegmentedControl);
    MIOCoreRegisterClassByName("MUIDatePicker", MUIDatePicker);
    MIOCoreRegisterClassByName("MUIComboBox", MUIComboBox);
    MIOCoreRegisterClassByName("UICollectionView", UICollectionView);
    MIOCoreRegisterClassByName("UICollectionViewCell", UICollectionViewCell);
    MIOCoreRegisterClassByName("UITableView", UITableView);
    MIOCoreRegisterClassByName("UITableViewCell", UITableViewCell);
    MIOCoreRegisterClassByName("HeaderCell", HeaderCell);
    MIOCoreRegisterClassByName("StepView", StepView);
    MIOCoreRegisterClassByName("UICheckButton", UICheckButton);    
    MIOCoreRegisterClassByName( "AppDelegate", AppDelegate );
    MIOCoreRegisterClassByName( "BookingDesktopViewController", BookingDesktopViewController );
    MIOCoreRegisterClassByName( "BookingProductCategoryViewController", BookingProductCategoryViewController );  
    MIOCoreRegisterClassByName( "BookingProductViewController", BookingProductViewController );  
    MIOCoreRegisterClassByName( "BookingCalendarViewController", BookingCalendarViewController );    
    MIOCoreRegisterClassByName( "BookingClientViewController", BookingClientViewController );
    MIOCoreRegisterClassByName( "BookingRestaurantViewController", BookingRestaurantViewController );    
    MIOCoreRegisterClassByName( "BookingProductCell", BookingProductCell );    
    MIOCoreRegisterClassByName( "BookingProductCategoryCell", BookingProductCategoryCell );
    MIOCoreRegisterClassByName( "BookingProductCategoryHeader", BookingProductCategoryHeader );
    MIOCoreRegisterClassByName( "BookingReviewViewController", BookingReviewViewController );
    MIOCoreRegisterClassByName( "BookingReviewCell", BookingReviewCell );
    MIOCoreRegisterClassByName( "BookingProductReviewViewController", BookingProductReviewViewController );
    MIOCoreRegisterClassByName( "UIImageView", UIImageView );
}